import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      data-testid="notfound-page"
      className="ct-container flex min-h-[60vh] flex-col items-center justify-center py-24 text-center"
    >
      <p className="ct-eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl font-bold tracking-tight text-[#0F172A] md:text-6xl">
        Page not found.
      </h1>
      <p className="mt-4 max-w-md text-base text-slate-600">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] px-6 py-3 text-sm font-semibold text-white hover:bg-[#262626]"
      >
        Back to home
      </Link>
    </section>
  );
}
